var e, s;
function n() {
  if (s) return e;
  s = 1;
  return e = class {
    constructor(e, s) {
      this.sender = e, this.licenses = s;
    }
    send(e) {
      return 0 !== this.licenses.length && (e.parameters.license = this.licenses.join(",")), new Promise((s, n) => {
        this.sender.send(e).then(s).catch(n);
      });
    }
  };
}
export { n as __require };